import React from 'react';
import { format } from 'date-fns';

import { shortDateTimeFormat } from '@crm-package/app';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const UnprocessedWithdrawRequestDetails: React.FC<
  INotificationGridItem
> = ({ date, notificationDetails: { data } }) => {
  const message = `Unprocessed withdrawal request ${data.id} from ${format(
    new Date(data.createdDate),
    shortDateTimeFormat
  )}.`;

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow
        label="Client ID"
        component={<LeadInfo leadId={data.leadId} />}
      />
      <DetailsRow label="Name" value={data.leadFullName} />
      <DetailsRow label="Message" value={message} />
      <DetailsRow label="Amount" value={`${data.amount} ${data.currency}`} />
    </>
  );
};
